/* eslint-disable */ 
//import _ from 'lodash'
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import {  getUpcomingEvents  } from '../api'
import { exportCSV, tableOptions} from '../common'
import { UpcomingEventsHeaders } from '../../../utils/constants';

// type Myprops = {divID: number};
export default class UpcomingEventsPage extends Component  {

  constructor(props) {
    super(props);
    this.state = {      
      upcomingEvents:[]
    };
  }
  
  componentDidMount() {
    const _this = this
      getUpcomingEvents().then(function(response) {
        _this.setState({upcomingEvents: response.data}); 
    })
   }

   centerFormatter(cell, row) {
    
      return (
        <span>
           <b>{row.centerName}</b><br/>
           {row.address}<br/>
           {row.city}, {row.state} {row.zipcode}<br/>
        </span>
      );    
  }   

  directorFormatter(cell, row) {
    
    return (
      <span>
         <b>{row.directorName}</b><br/>
         {row.directorAddressLines}<br/>
         {row.directorCity}, {row.directorState} {row.directorZipCode}<br/>
         {row.directorPhoneNumber}<br/>
         <a href={'mailto:'+row.directorSSOEmail}>{row.directorSSOEmail}</a>         
      </span>
    );    
}   

  render() {
    const _this = this
     const { match } = _this.props
     const {upcomingEvents}=_this.state;   
     var seasonName = match.params.seasonName
     //console.log("upcomingEvents: ", upcomingEvents);
    return (
      <div>
      <Navwrapper />
      <div className="container-fluid">
        <Row>
          <div className="pageHeading" >
              <h4>{seasonName}</h4>
              <h4></h4>
                <h4 >
                        Upcoming Events
                </h4>
          </div>
        </Row>      
        <Row>                 
          <Col xs={12} >                           
            <div className="rankingRightColumn_"> 
            <BootstrapTable 
                  data={upcomingEvents} 
                  striped 
                  hover 
                  options={tableOptions}
                  pagination               
                >
                  <TableHeaderColumn          
                    dataField="eventId" 
                    isKey 
                    dataAlign="right" 
                    dataSort 
                    data-Visible="false"               
                    hidden                 
                  >ID
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="date" dataSort width="20%" >DATE
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="name" dataSort  width="40%">EVENT
                  </TableHeaderColumn>                  
                  <TableHeaderColumn dataField="centerName" dataSort dataFormat={this.centerFormatter} tdStyle={ { whiteSpace: 'normal' } }  width="30%">CENTER
                  </TableHeaderColumn>          
                  <TableHeaderColumn dataField="directorName" dataSort dataFormat={this.directorFormatter} tdStyle={ { whiteSpace: 'normal' } }  width="30%">DIRECTOR
                  </TableHeaderColumn>                                                  
                  {/* <TableHeaderColumn dataField="location" dataSort  width="30%">LOCATION           
                  </TableHeaderColumn> */}

                  {/* <TableHeaderColumn dataField="country"   width="30%">COUNTRY
                  </TableHeaderColumn>               */}
                </BootstrapTable>
            </div>
          </Col>
        </Row>
        { exportCSV(upcomingEvents,UpcomingEventsHeaders,'Upcoming-Events.csv') }
      </div>
      <Footer />
    </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/upcomingEvents/index.js